import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;
